module.exports = __webpack_public_path__ + "static/media/glasgiven.615144ef.jpg";